import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { getCommuneBySlug } from '@/services/cmsService';
import { SBackButton } from '@slg/web-customer-shared';
import VueMarkdown from 'vue-markdown';
import { useStore, useRouteRef, useCmsLocaleReload } from '@/composables';


import { getMetaInfo } from '@/utils/seo';

const __default__ = {
  name: 'CommunePage',
  metaInfo() {
    return getMetaInfo((this as { seo?: unknown }).seo);
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRouteRef();
const title = ref('');
const description = ref('');
const pageKey = ref(new Date().toString());
const contactCommune = ref('');
const opening = ref('');
const seo = ref<any>('');
const subTitle = ref('');
const cmsData = ref(null);

async function loadCmsData() {
  store.commit('common/setGlobalLoading', true);
  try {
    const slug = route.value.params.name as string;
    const data = await getCommuneBySlug(slug) as any;
    seo.value = data?.Seo || '';
    title.value = data?.Title || '';
    subTitle.value = data?.Subtitle || '';
    description.value = data?.Description || '';
    opening.value = data?.Opening || '';
    contactCommune.value = data?.ContactCommune || '';
    pageKey.value = new Date().toString();
    seo.value = data?.Seo || '';
  } catch (error) {
    cmsData.value = null;
  } finally {
    store.commit('common/setGlobalLoading', false);
  }
}

useCmsLocaleReload(loadCmsData);

return { __sfc: true,store, route, title, description, pageKey, contactCommune, opening, seo, subTitle, cmsData, loadCmsData, SBackButton, VueMarkdown }
}

})